import { Grid } from '@mui/material';
import { TVNZ_LOGO_IMAGE_PATH } from '../../constants';
import { Divider } from '../Divider';
import { Slider } from '../Slider';
import NetworkBreakdownSwitch from './NetworkBreakdownSwitch';
import NetworkBreakdownLogo from './NetworkBreakdownLogo';

interface NetworkBreakdownSectionProps {
  title: string;
  image: TVNZ_LOGO_IMAGE_PATH;
  value: number;
  loading: number;
  toggle: boolean;
  onToggleChange: (value: boolean) => void;
  onChange: (value: number) => void;
}

const NetworkBreakdownSection = ({
  title,
  image,
  onChange,
  onToggleChange,
  loading,
  value,
  toggle
}: NetworkBreakdownSectionProps) => {
  const handleSwitch = (toggle: boolean): void => {
    onToggleChange(toggle);
  };

  const handleSliderChange = (_: Event, value: number | number[]): void => {
    const newValue = value as number;
    onChange(newValue);
  };

  return (
    <Grid item xs={12}>
      <Grid
        container
        spacing={2}
        paddingTop={'16px'}
        paddingBottom={'16px'}
        justifyContent="center"
        alignItems="center"
      >
        <Grid item xs={1.5}>
          <NetworkBreakdownLogo image={image} loading={loading} />
        </Grid>
        <Grid item xs={10.5}>
          <h3>{title}</h3>
          {!toggle && (
            <Slider
              minimumValue={0}
              maximumValue={100}
              step={5}
              value={value}
              onChange={handleSliderChange}
            />
          )}
          <NetworkBreakdownSwitch
            onSwitchChange={(checked: boolean) => handleSwitch(checked)}
            toggle={toggle}
          />
        </Grid>
      </Grid>
      <Divider />
    </Grid>
  );
};

export default NetworkBreakdownSection;
